export default __webpack_public_path__ + "static/media/IMG_2226 copie.17ec31dd.jpg";